import type {CategoryResponse} from '../widget-sources/types.js';

export const CONTROL_VALUES_LIMIT = 1000;

export type ControlValues = {
  values: string[];
  hasMore: boolean;
  hasNull: boolean;
  /** Distinct non-null values up to the maps-api row limit (200,000 by default); a lower bound past it. */
  total: number;
};

export function shapeControlValues(
  categories: CategoryResponse
): ControlValues {
  const names = new Set<string>();
  let hasNull = false;
  for (const {name} of categories) {
    if (name === null || name === undefined) hasNull = true;
    else names.add(String(name));
  }

  return {
    values: [...names].slice(0, CONTROL_VALUES_LIMIT),
    hasMore: names.size > CONTROL_VALUES_LIMIT,
    hasNull,
    total: names.size,
  };
}
